module.exports = __webpack_public_path__ + "img/lineup24@2x.b0df9c1f.png";